import { QuestionStepShell } from "./QuestionStepShell";
import type { QuestionStepProps } from "./types";

/** Scenario-vraag: situatie, prompt en vijf antwoordkeuzes. */
export function QuestionStepScenario({
  question,
  questionIndex,
  totalQuestions,
  selectedValue,
  onSelect,
  onBack,
  canGoBack,
}: QuestionStepProps) {
  const options = question.options ?? [];

  return (
    <QuestionStepShell
      question={question}
      questionIndex={questionIndex}
      totalQuestions={totalQuestions}
      selectedValue={selectedValue}
      onSelect={onSelect}
      onBack={onBack}
      canGoBack={canGoBack}
    >
      <div className="bloom-scenario" role="group" aria-label="Antwoordopties">
        {options.map((option) => (
          <button
            key={option.score}
            type="button"
            className={`bloom-scenario__option${
              selectedValue === option.score ? " bloom-scenario__option--selected" : ""
            }`}
            aria-pressed={selectedValue === option.score}
            onClick={() => onSelect(option.score)}
          >
            {option.text}
          </button>
        ))}
      </div>
    </QuestionStepShell>
  );
}
